import { AppFormItem, AppFormItemProps } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { journalTexts } from 'consts/text';
import { IconPlus } from '@tabler/icons-react';
import { ChildId, SelectOptionType } from 'types';
import { AppCustomSelect } from 'components/atoms/CommonAppComponents/AppSelect/AppCustomSelect/AppCustomSelect';

export type SpecialJournalChildrenPickerElementProps = AppFormItemProps & {
    onClick: () => void;
    onClear: () => void;
    isLoading: boolean;
    options: SelectOptionType<ChildId>[];
};

export const SpecialJournalChildrenPickerElement = ({
    onClick,
    onClear,
    isLoading,
    options,
    ...props
}: SpecialJournalChildrenPickerElementProps) => (
    <AppFormItem
        label={journalTexts.journals.addChildren}
        name={formFields.childIdsToAdd}
        accessibilityLabel="Pole dodaj dzieci"
        {...props}
    >
        <AppCustomSelect
            mode="multiple"
            suffixIcon={<IconPlus size={20} />}
            onClick={onClick}
            onClear={onClear}
            loading={isLoading}
            options={options}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick();
                }
            }}
            tabIndex={0}
            aria-label={`${journalTexts.journals.addChildren}. Naciśnij Enter lub Spację aby otworzyć`}
            placeholder="Wybierz dzieci"
        />
    </AppFormItem>
);
